<template>
  <div class="input">
    <el-form-item :label="label" :prop="name">
      <el-input ref="input" v-model="value" :placeholder="placeholderText(label)" @input="onInput(name, $event)"
                clearable/>
    </el-form-item>
  </div>
</template>
<script>
import {placeholderText} from '@/tools/common-utils';

export default {
  props: {
    name: String,
    label: String,
    type: String,
    activeIndex: String
  },
  data: function () {
    return {
      value: null
    }
  },
  watch: {
    activeIndex: function () {
      this.value = null
    }
  },

  computed: {},
  methods: {
    placeholderText,
    onInput: function (name, val) {
      val = typeof (val) === 'string' ? _.trim(val) : val
      if (this.type === 'number') {
        val = val === '' ? NaN : _.toNumber(val)
      }
      this.$emit('input', {[name]: val});
    }
  }
}
</script>
<style scoped>
.input >>> .el-input {
  width: 150px;
}

.input {
  display: inline;
}
</style>
